export function isKindAndId(kind, id) {
  return (a, c) => {
    if (c.kind === kind && c.item_id === id) {
      a = true;
    }
    return a;
  };
}
